import React, { Component } from 'react';
import logo from './content/Filter.png';
export default class Header extends Component {
    render() {
        return (
            <img src={logo} style={{ marginLeft:'10px' }} alt='filter'/>
        );
    }
}